import { render, staticRenderFns } from "./currencySelectionModal.vue?vue&type=template&id=0dfa257f&scoped=true"
import script from "./currencySelectionModal.vue?vue&type=script&lang=js"
export * from "./currencySelectionModal.vue?vue&type=script&lang=js"
import style0 from "./currencySelectionModal.vue?vue&type=style&index=0&id=0dfa257f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfa257f",
  null
  
)

export default component.exports